import { $sections } from '@/services/'
import Vue from 'vue'
const module = {
  namespaced: true,

  state: {
    items: [],
    item: {},
    meta: { pagination: {} },
    currentMode: null,
    currentDrawingTool: null,
    currentEquipmentConfig: null,
    underCopy: false,
    copyData: {
      enabled: false,
      section: {},
      sectionShape: null,
      initiateCopy:  null
    },
    equipmentMarkerIconsList: []
  },

  getters: {
    items: state => state.items,
    item: state => state.item,
    meta: state => state.meta,
    currentMode: state => state.currentMode,
    currentShape: state => {
      let shape;
      switch(state.currentMode){
        case 'roof': 
          shape = 'polygon'
          break
        case 'equipment':
          shape = state.currentEquipmentConfig.shape_type
          break
        case 'unit-scale':
          shape = 'polyline'
          break
        default:
          shape = ''
          break
      }
      return shape
    },
    currentDrawingTool: state => state.currentDrawingTool,
    currentEquipmentConfig: state => state.currentEquipmentConfig,
    underCopy: state => state.underCopy,
    copyData: state => state.copyData,
    equipmentMarkerIconsList: state => state.equipmentMarkerIcons

  },

  mutations: {

    ITEM(state,value){
      state.item = value
    },

    ITEMS(state,value){
      state.items = value
    },
    

    ADD_ITEM(state, value){
      state.items.push(value)
    },

    META(state, meta){
      state.meta = meta
    },

    UPDATE(state, {id, data}){
      var index = state.items.findIndex(obj => obj.id == id)
      index > -1 && Vue.set(state.items, index, data)
      if(state.item.id == id){
        state.item = {...state.item, ...data}
      }
      if(this.getters['projects/item'].asset_type == 'drone'){
        this.dispatch('gmap/updateShape', data)
      }
    },

    SET_EQUIPMENT_MARKER_ICONS(state, icons) {
      state.equipmentMarkerIcons = icons;
    },
    
    DELETE(state, id){
      let index = state.items.findIndex(i => i.id == id)
      index > -1 && state.items.splice(index,1)
      if(this.getters['projects/item'].asset_type == 'drone'){
        this.dispatch('gmap/deleteShape', id)
      }
    },

    CURRENT_MODE(state, {mode, equipmentId}){
      state.currentMode = mode
      if(mode == 'roof'){
        state.item = {}
        state.currentEquipmentConfig = null
        state.currentDrawingTool = 'polygon'
        if(this.getters['projects/item'].asset_type == 'drone'){
          this.getters['gmap/drawingManager'].setDrawingMode('polygon')
        }
      } else if(equipmentId) {
        const equipments = this.getters['equipments/items']
        const equipment = equipments.filter(eq => eq.id == parseInt(equipmentId))[0]
        state.item.equipment_detail = { 
          ...state.item.equipment_detail, 
          ...{ equipment_config: equipment }
        }
        state.currentEquipmentConfig = equipment
        state.currentDrawingTool = equipment.shape_type
        if(this.getters['projects/item'].asset_type == 'drone'){
          this.getters['gmap/drawingManager'].setDrawingMode(google.maps.drawing.OverlayType[equipment.shape_type.toUpperCase()])
        }
      } else if(mode == 'note') {
        state.item = {}
        state.currentEquipmentConfig = null
        state.currentDrawingTool = 'marker'
        if(this.getters['projects/item'].asset_type == 'drone'){
          this.getters['gmap/drawingManager'].setDrawingMode('marker')
        }
      }else {
        state.item = {}
        state.currentEquipmentConfig = null
        state.currentDrawingTool = null
        if(this.getters['projects/item'].asset_type == 'drone'){
          this.getters['gmap/drawingManager'].setDrawingMode(null)
        }
      }
    },

    RESET_ITEM(state){
      if(state.currentMode == 'roof'){
        this.commit("sections/ITEM", {})
      } else if(state.currentMode == 'equipment'){
        const item = { equipment_detail: { equipment_config: state.item.equipment_detail?.equipment_config } }
        this.commit("sections/ITEM", item)
      } else {
        this.commit("sections/ITEM", {})
      }
      if(this.getters['projects/item'].asset_type == 'drone'){
        this.dispatch('gmap/setSelectedShape', {value: null, autoZoom: null})
      }
    },

    EQUIPMENT_CONFIG(state, value){
      state.currentEquipmentConfig = value
    },

    SET_COPY_STATE(state, value){
      state.underCopy = value
    },

    SET_COPY_DATA(state, {enabled, section, sectionShape, initiateCopy}){
      state.copyData = {
        enabled: enabled,
        section: section,
        sectionShape: sectionShape,
        initiateCopy: initiateCopy
      }
    },

    BULK_DELETE_SECTIONS(state, ids){
      state.items = state.items.filter(item => !ids.includes(item.id))
      if(this.getters['projects/item'].asset_type == 'drone'){
        this.dispatch('gmap/bulkDeleteShapes', ids, { root: true });
      }
    }
  },

  actions: {
    
    all({ commit }, { projectId, config }){
      let asset = this.getters['assets/assetDetail']

      let asset_detail_id = null
      if(asset){
        asset_detail_id = asset.id
      }
      config = config || {}
      config = {
        ...{
          params: {
            include: ['equipment_detail', 'equipment_detail.equipment_config', 'divalto_codes']
          }
        },
        ...config
      }
      return $sections._(projectId).all(config)
        .then(function(res){
          let {data, meta} = res.data
          commit('ITEMS', data.filter(e=>asset_detail_id == null || e.asset_detail_id == asset_detail_id))
          commit('META', meta)
          return res
        })
    },

    create({ commit }, {projectId, payload, config }){
      return $sections._(projectId).create(payload, config)
      .then(res => {
        commit('ADD_ITEM', res.data.data)
        return res
      })
    },

    find({ commit }, {projectId, id, config }){
      return $sections._(projectId).show(id, config)
      .then(res => {
        commit('ITEM', res.data.data)
        return res
      })
    },

    delete({commit}, {projectId, id}){
      return $sections._(projectId).delete(id)
      .then(() => {
        commit('DELETE', id)
      })
    },

    update({commit}, {projectId, id, payload, config}){
      return $sections._(projectId).update(id, payload, config).then(res => {
        let section = res.data.data
        commit("UPDATE", {
          id: section.id,
          data: section
        })
        return res
      })
    },

    bulkUpdate({commit}, {projectId, id, payload, config}){
      return $sections._(projectId).update(id, payload, config).then(res => {
        let section = res.data.data
        return res
      })
    },

    bulkDeleteSections({commit}, payload){
      return $sections._(payload.projectId).bulkDeleteSections(payload).then((res) => {
        commit('BULK_DELETE_SECTIONS', payload.sectionIds);
        return res
      })
    },

    copyDroneSection({commit}, {center}) {
        let section = this.getters['sections/copyData'].section
        let polygonCoords = section.coords

        if(section.shape_type === 'marker'){
          polygonCoords = [section.center_coords]
        }
        
        let latSum = 0, lngSum = 0;
        polygonCoords.forEach(coord => {
            latSum += coord.lat;
            lngSum += coord.lng;
        });
        const originalCenter = {
            lat: latSum / polygonCoords.length,
            lng: lngSum / polygonCoords.length
        };

        const newPolygonCoords = polygonCoords.map(coord => {
            return {
                lat: center.lat() + (coord.lat - originalCenter.lat),
                lng: center.lng() + (coord.lng - originalCenter.lng)
            };
        });

        let sectionLabel = (section.label || '');
        const regex = /^([^\(]+)(?=\s*\(\d+\))?/;
        const match = sectionLabel.match(regex)
        if(match){
          sectionLabel = match[1].trim()
        }
        const filteredItems = (this.getters['sections/items'] || []).filter(item => {
          const itemMatch = (item.label || '').match(regex)
          if(itemMatch){
            return (itemMatch[1].trim() == sectionLabel)
          } else {
            return (item.label == sectionLabel)
          }
        })

        const config = {
          params: {
            include: ['equipment_detail', 'equipment_detail.equipment_config']
          }
        }

        const payload = {
          section: {
            ...section,
            ...{
                  label: `${(sectionLabel || 'copie')} (${filteredItems.length})`,
                  coords: newPolygonCoords,
                  divalto_code_ids: (section.divalto_codes || []).map( c => c.id),
                  center_coords: {lat: center.lat(), lng: center.lng()}
                },
            ...{
              equipment_detail: {
                ...section.equipment_detail,
                ...{id: null}
              }
            }
          }
        }
        return $sections._(section.project_id).create(payload, config)
        .then(res => {
          let section = res.data.data
          this.commit('canvas/dragEquipId', section.id)
          commit('ADD_ITEM', section)
          return res
        })
    },

    copySection({commit}, {section, center}){
      commit('SET_COPY_STATE', true)

      let xKey = 'x'
      let yKey = 'y'
      if(this.getters['projects/item'].asset_type == 'drone'){
        xKey = "lat"
        yKey = "lng"
      }
      
      if(section.coords && this.getters['projects/item'].asset_type == 'drone'){
        section.coords = (section.coords || []).map(x => x instanceof google.maps.LatLng ? x.toJSON() : x)
      }

      const minLat = Math.min(...(section.coords || []).map(c => c[xKey]))
      const minLng = Math.min(...(section.coords || []).map(c => c[yKey]))
      const maxLat = Math.max(...(section.coords || []).map(c => c[xKey]))
      const maxLng = Math.max(...(section.coords || []).map(c => c[yKey]))
      let deltaLat = 0.000001
      let deltaLng = 0.000001
      if(section.shape_type == 'polygon' || section.shape_type == 'polyline'){
        deltaLat = maxLat - minLat
        deltaLng = maxLng - minLng
      }

      if(this.getters['projects/item'].asset_type == 'drone' && section.center_coords instanceof google.maps.LatLng){
        section.center_coords = section.center_coords.toJSON()
      }

      if(section.shape_type == 'marker' && this.getters['projects/item'].asset_type != 'drone'){
        deltaLat = 30
        deltaLng = 30
      }

      let sectionLabel = (section.label || '');
      const regex = /^([^\(]+)(?=\s*\(\d+\))?/;
      const match = sectionLabel.match(regex)
      if(match){
        sectionLabel = match[1].trim()
      }
      const filteredItems = (this.getters['sections/items'] || []).filter(item => {
        const itemMatch = (item.label || '').match(regex)
        if(itemMatch){
          return (itemMatch[1].trim() == sectionLabel)
        } else {
          return (item.label == sectionLabel)
        }
      })

      section.label = `${(sectionLabel || 'copie')} (${filteredItems.length})`

      let payload = {
        section: {
          ...section,
          ...{
                coords: (section.coords || []).map(c =>  {return {[xKey]: c[xKey] + deltaLat, [yKey]: c[yKey] + deltaLng}}),
                center_coords: {[xKey]: section.center_coords[xKey] + deltaLat, [yKey]: section.center_coords[yKey] + deltaLng},
                divalto_code_ids: (section.divalto_codes || []).map( c => c.id)
              },
          ...{
            equipment_detail: {
              ...section.equipment_detail,
              ...{id: null}
            }
          }
        }
      }
      return $sections._(section.project_id).create(payload, config)
      .then(res => {
        let section = res.data.data
        this.commit('canvas/dragEquipId', section.id)
        commit('ADD_ITEM', section)
        return res
      })
    },

    setCurrentMode({commit}, {mode, equipmentId}){
      // this.getters["projects/item"].asset_type
      commit('CURRENT_MODE', {mode, equipmentId})
    },

    resetItem({commit}){
      commit("RESET_ITEM")
    },

    reset({commit}){
      this.dispatch('sections/resetItem')
      commit("CURRENT_MODE", {})
    },

    setItem({commit}, itemId){
      commit('ITEM', this.getters['sections/items'].filter(item => item.id == itemId)[0])
    },

    selectItem({commit}, itemId){
      const projectId = this.getters['projects/item'].id
      this.dispatch('sections/find', {
        projectId: projectId, 
        id: itemId, 
        config: {
          params: {
            include: ['equipment_detail', 'equipment_detail.equipment_config', 'divalto_codes']
          }
        }
      }).then(resp => {
        commit('ITEM', resp.data.data)
        itemId = parseInt(itemId)
        
        if(this.getters['projects/item'].asset_type == 'drone'){
          const shape = this.getters['gmap/allShapes'].filter(sh => sh.id == itemId)[0]
          this.dispatch('gmap/setSelectedShape', {value: shape, autoZoom: !(this.getters['sections/underCopy'])})
          // commit('SET_COPY_STATE', false)
        }
      })
    },

    setCurrenEquipmentConfig({commit}, item){
      commit('EQUIPMENT_CONFIG', item)
    },

    setCopyData({commit}, {enabled, section, sectionShape, initiateCopy}){
      commit('SET_COPY_DATA', {enabled, section, sectionShape, initiateCopy})
    },

    cancelCopy({commit}){
      commit('SET_COPY_DATA', {enabled: false, section: {}, sectionShape: null, initiateCopy: null})
      commit('SET_COPY_STATE', false)
    },

    setOrToggleCopyState({commit}, value){
      if(value !== undefined || value !== null){
        commit('SET_COPY_STATE', value)
      }else{
        commit('SET_COPY_STATE', !(this.getters['sections/underCopy']))
      }
    }
  }
}

export default module
